import React, { FC } from 'react';
import { RouteComponentProps, Switch, Redirect } from 'react-router-dom';
import { NOT_FOUND_ERROR_PAGE_PATH } from 'src/app/common/constants';
import PruRoute from 'src/app/common/components/PruRoute';
import ParamsProvider from 'src/app/common/components/ParamsProvider';
import { surveyFilterKeys } from 'src/app/modules/Survey/pages/Management/List/SurveyListingPage';
import CustomerSurveyListingPage from './List/CustomerSurveyListingPage';
import { SURVEY_CUSTOMER_PATH } from '../../constants';
import CustomerSurveyDetailPage from './Create/CustomerSurveyDetailPage';
import CustomerSurveyAnalyticPage from './Analytics/CustomerSurveyAnalyticPage';
import { SURVEY_BASE_PATH } from 'src/app/modules/Survey/constants';

const CustomerSurveyManagementPage: FC<RouteComponentProps> = ({ history }) => {
  return (
    //PHKL Custom - s
    <Switch>
      <Redirect
        exact
        from={`${SURVEY_BASE_PATH}${SURVEY_CUSTOMER_PATH}`}
        to={`${SURVEY_BASE_PATH}${SURVEY_CUSTOMER_PATH}/list`}
      />
      <PruRoute
        exact
        path={`${SURVEY_BASE_PATH}${SURVEY_CUSTOMER_PATH}/list`}
        render={(props) => (
          <ParamsProvider {...props} acceptKeys={surveyFilterKeys}>
            <CustomerSurveyListingPage />
          </ParamsProvider>
        )}
      />
      <PruRoute
        exact
        path={`${SURVEY_BASE_PATH}${SURVEY_CUSTOMER_PATH}/edit/:id`}
        component={CustomerSurveyDetailPage}
      />
      <PruRoute exact path={`${SURVEY_BASE_PATH}${SURVEY_CUSTOMER_PATH}/create`} component={CustomerSurveyDetailPage} />
      <PruRoute
        exact
        path={`${SURVEY_BASE_PATH}${SURVEY_CUSTOMER_PATH}/:id/results`}
        component={CustomerSurveyAnalyticPage}
      />
      <Redirect to={NOT_FOUND_ERROR_PAGE_PATH} />
    </Switch>
    //PHKL Custom - e
  );
};

export default CustomerSurveyManagementPage;
